import { roleName, level, gender, language } from "@/biz/static-data";
import { getUserInfo, getToken } from "@/utils/auth";
import store from "@/store";
export const mixin = {
  data() {
    return {
      levels: [],
      genders: [],
      userInfo: {
        roleName: "",
      },
      roleNameStudent: "",
      roleNameParent: "",
      languageZhTc: "",
      languageEn: "",
      refreshToken: "",
      token: null,
      langList: ["中文 Chinese","英文 English"],
    };
  },
  created() {
    this.languageEn = language.en;
    this.languageZhTc = language.zh_tc;
    this.levels = level;
    this.genders = gender[store.getters.language];
    // this.genders = gender["en"]
    this.roleNameStudent = roleName.student;
    this.roleNameParent = roleName.parent;
    if (getToken() != null) {
      this.token = getToken();
    }
    if (getUserInfo("userInfo") != null) {
      this.userInfo = getUserInfo("userInfo");
    }
    if (getUserInfo("refreshToken") != null) {
      this.refreshToken = getUserInfo("refreshToken");
    }
  },
  methods: {
    onBack() {
      this.$router.go(-1);
    },
    isEmpty(obj) {
      if (typeof obj == "undefined" || obj == null || obj == "") {
        return true;
      } else {
        return false;
      }
    },
  },
};
